module.exports = __webpack_public_path__ + "static/img/12-北京市第十八中学(左安门校区).300dbb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/12-北京市第十八中学(左安门校区).png
// module id = JgpT
// module chunks = 0